var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbag7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93164 8.84337H14.0685V11.8795C14.0685 12.9974 13.1425 13.9036 12.0001 13.9036C10.8578 13.9036 9.93164 12.9974 9.93164 11.8795V8.84337ZM12.0001 12.8916C12.5713 12.8916 13.0343 12.4385 13.0343 11.8795C13.0343 11.3206 12.5713 10.8675 12.0001 10.8675C11.4289 10.8675 10.9659 11.3206 10.9659 11.8795C10.9659 12.4385 11.4289 12.8916 12.0001 12.8916Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11918 8.84337C6.07571 8.51147 6.05329 8.17336 6.05329 7.83132C6.05329 4.19395 8.58931 1 12 1C15.4107 1 17.9467 4.19395 17.9467 7.83132C17.9467 8.17336 17.9243 8.51147 17.8808 8.84337H19.9311C21.1988 8.84337 22.1683 9.94913 21.9755 11.1752L20.5435 20.2837C20.3883 21.2711 19.5201 22 18.4992 22H5.50085C4.47994 22 3.61172 21.2711 3.45648 20.2837L2.0245 11.1752C1.83173 9.94913 2.80116 8.84337 4.06887 8.84337H6.11918ZM7.6046 7.83132C7.6046 8.18003 7.63163 8.51807 7.6829 8.84337H8.38028V11.8795C8.38028 13.8358 10.0009 15.4217 12 15.4217C13.9991 15.4217 15.6198 13.8358 15.6198 11.8795V8.84337H16.3171C16.3684 8.51807 16.3954 8.18003 16.3954 7.83132C16.3954 4.76144 14.3011 2.51807 12 2.51807C9.6989 2.51807 7.6046 4.76144 7.6046 7.83132Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag7);
export default __webpack_public_path__ + "static/media/handbag-7.17cada42ce4244f7a2116b9dcd2fc593.svg";
export { ForwardRef as ReactComponent };